export const en = {
  button_reload_text: 'Reload',
  button_reload_in_progress: 'Loading...',
  button_reload_title: 'Reload table data',

  button_export_text: 'Export',
  button_export_in_progress: 'Exporting...',
  button_export_title: 'Download table data as CSV',

  overlay_loading_text: 'Loading...',

  column_selector_button_text: 'Columns',
  column_selector_apply_text: 'Apply',
  column_selector_close_text: 'Close',

  records_text: 'Showing ${visibleRowCount} records',
  records_filtered_text:
    'Showing ${visibleRowCount} from ${totalRowCount} records',

  checkboxRowSelectionHeaderToolTip: 'Select/Deselect All',
};

export const hu = {
  button_reload_text: 'Frissítés',
  button_reload_loading: 'Betöltés...',
  button_reload_title: 'Adatok újratöltése',

  button_export_text: 'Adatexport',
  button_export_in_progress: 'Adatexport...',
  button_export_title: 'Adatok letöltése CSV formátumban',

  overlay_loading_text: 'Betöltés...',

  column_selector_button_text: 'Oszlopok',
  column_selector_apply_text: 'Mentés',
  column_selector_close_text: 'Mégsem',

  records_text: '${visibleRowCount} rekord',
  records_filtered_text: '${visibleRowCount}/${totalRowCount} rekord',

  checkboxRowSelectionHeaderToolTip: 'Az összes kijelölése',
};
